import { AddonLfButtonModel } from '@/components/addons/lf-button/Model';
import { SdkTypeCheck } from '@/sdk/utilities';
import { SdkBaseAddonModel } from '.';

export class SdkAddonButton extends SdkBaseAddonModel {
  #model: AddonLfButtonModel;

  constructor(model: AddonLfButtonModel) {
    super(model);
    this.#model = model;
  }

  get label(): string {
    return this.#model.state.label;
  }
  set label(value: string) {
    try {
      SdkTypeCheck('string', value);

      this.#model.state.label = value;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }
}
